import { atom } from 'jotai';

export const giftCategoryIdAtom = atom<string>('');
